import React, { useState, useEffect, useContext } from 'react';
import { MenuItem, Button } from '@material-ui/core';
import { clDeliveredOrderLineStatusLookupId, qaCompletedOrderLineStatusLookupId } from '../QaOrderReview/constants';
import { OrderReviewContext } from '../QaOrderReview/OrderReviewContext';
import { ConfirmationDialog } from '../ConfirmationDialog';
import { Autocomplete } from '../Autocomplete';
import { cancelOrderLine, getOrderCancellationReasons, getOrderById } from '../../services';
import { useHistory } from 'react-router';
import { AppContext } from '../../AppContext';

export const CancelOrderButton = ({ orderLineId }) => {
  const { dispatch } = useContext(AppContext);
  const history = useHistory();

  const [isCancelingOrder, setIsCancelingOrder] = useState(false);
  const [canceledOrderMessage, setCanceledOrderMessage] = useState(null);
  const [cancelDialogVisible, setCancelDialogVisible] = useState(false);
  const [selectedCancellationReasonOption, setSelectedCancellationReasonOption] = useState(null);
  const [cancellationReasonOptions, setCancellationReasonOptions] = useState([]);
  const [cancelComment, setCancelComment] = useState('');

  const handleCancelOrder = async () => {
    setIsCancelingOrder(true);
    setCanceledOrderMessage(null);

    try {
      const result = await cancelOrderLine(orderLineId, selectedCancellationReasonOption.value, cancelComment);
      dispatch({
        type: 'SET_SNACKBAR',
        snackbar: {
          isOpen: true,
          message: result.message,
          variant: result.success ? 'success' : 'error',
        },
      });
      history.push('/orders/qa');
      setCancelDialogVisible(false);
    } catch (error) {
      dispatch({
        type: 'SET_SNACKBAR',
        snackbar: {
          isOpen: true,
          message: error.message || 'Something happened during cancellation',
          variant: 'error',
        },
      });
    } finally {
      setIsCancelingOrder(false);
    }
  };

  const handleDialogOpen = () => {
    setCancelDialogVisible(true);
  };

  useEffect(() => {
    const getOrderCancellationReasonsAsync = async () => {
      try {
        const reasons = await getOrderCancellationReasons();

        const mappedReasons = reasons.map(r => ({
          value: r.cancellationReasonId,
          label: r.name,
        }));
        setCancellationReasonOptions(mappedReasons);

        // set the selected reason
        // setSelectedCancellationReasonOption(mappedReasons.find(r => r.value === orderInfo.cancellationReasonId));
      } catch (error) {
        console.log(error);
      }
    };

    getOrderCancellationReasonsAsync();
  }, []);

  return (
    <>
      <MenuItem
        onClick={handleDialogOpen}
        // disabled={
        //   state.orderLineStatusLookupId !== qaCompletedOrderLineStatusLookupId &&
        //   state.orderLineStatusLookupId !== clDeliveredOrderLineStatusLookupId
        //     ? false
        //     : true
        // }
      >
        Cancel Order
      </MenuItem>

      <ConfirmationDialog
        visible={cancelDialogVisible}
        setVisibility={setCancelDialogVisible}
        title={'Order Cancellation'}
        disabled={isCancelingOrder}
        isSubmitting={isCancelingOrder}
        submitMessage={canceledOrderMessage}
        cancelButton={
          <Button
            disabled={isCancelingOrder}
            onClick={() => setCancelDialogVisible(false)}
            variant="contained"
            style={{ backgroundColor: '#315382', color: 'white', opacity: isCancelingOrder ? 0.5 : 1 }}
          >
            No
          </Button>
        }
        acceptButton={
          <Button
            disabled={isCancelingOrder || !selectedCancellationReasonOption}
            onClick={handleCancelOrder}
            variant="contained"
            style={{
              backgroundColor: '#F44336',
              color: 'white',
              opacity: isCancelingOrder || !selectedCancellationReasonOption ? 0.5 : 1,
            }}
          >
            Yes, cancel this order
          </Button>
        }
      >
        <div>Are you sure you want to cancel order #{orderLineId}?</div>

        <div style={{ marginTop: 35 }}>Why is this order being canceled?</div>
        <Autocomplete
          options={cancellationReasonOptions}
          value={selectedCancellationReasonOption}
          onChange={setSelectedCancellationReasonOption}
          placeholder={'Please select a cancellation reason'}
          styleOptions={{
            menu: (provided) => ({
              ...provided,
              zIndex: 1400,
            }),
            menuPortal: (provided) => ({
              ...provided,
              zIndex: 1400,
            }),
          }}
          isAbsolute={true}
          // error={}
          // hideLabel={true}
        />

        <div style={{ marginTop: 35 }}>Add any additional information that was not asked about here:</div>
        <textarea
          value={cancelComment}
          onChange={evt => setCancelComment(evt.target.value)}
          style={{ marginTop: 10, width: '100%' }}
          rows={10}
        />
      </ConfirmationDialog>
    </>
  );
};
